import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CONTACT_INFO } from "@/data/siteData";

const ContactStrip = () => (
  <section className="bg-[#2E4A91] py-12" data-testid="contact-strip">
    <div className="max-w-7xl mx-auto px-4 md:px-8">
      <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
        <div className="text-center lg:text-left">
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-2">
            Имате въпроси?
          </h3>
          <p className="text-white/80">
            Свържете се с нас за безплатна консултация
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center gap-6 text-white">
          <a
            href={`mailto:${CONTACT_INFO.email}`}
            className="flex items-center gap-3 hover:text-[#2ED573] transition-colors"
          >
            <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">
              <Mail className="w-5 h-5" />
            </div>
            <span className="font-medium">{CONTACT_INFO.email}</span>
          </a>
          <a
            href={`tel:${CONTACT_INFO.phone}`}
            className="flex items-center gap-3 hover:text-[#2ED573] transition-colors"
          >
            <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">
              <Phone className="w-5 h-5" />
            </div>
            <span className="font-medium">{CONTACT_INFO.phone}</span>
          </a>
        </div>

        <Link to="/kontakti">
          <Button className="bg-white text-[#2E4A91] hover:bg-slate-100 rounded-lg px-6 h-12 font-semibold">
            Към контакти
            <ArrowRight className="ml-2 w-4 h-4" />
          </Button>
        </Link>
      </div>
    </div>
  </section>
);

export default ContactStrip;
